import { render, staticRenderFns } from "./AdminVesselStatus.vue?vue&type=template&id=59a64437&scoped=true"
import script from "./AdminVesselStatus.vue?vue&type=script&lang=js"
export * from "./AdminVesselStatus.vue?vue&type=script&lang=js"
import style0 from "./AdminVesselStatus.vue?vue&type=style&index=0&id=59a64437&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a64437",
  null
  
)

export default component.exports